import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)

export const routes=[
  
  {
     path:"/",
     redirect:'/Home'
  },
  {
      path:'/Home', component: resolve => require(['../components/Home/Home.vue'], resolve)
  },
  {
    path:'/order', component: resolve => require(['../components/order/order.vue'], resolve),
    redirect:"/order/query",
    children:[
      // {
      //   path:"/order/overbooking",
      //   component:resolve => require(['../components/Overbooking/Overbooking.vue'], resolve),
      // },
      {
        path:"/order/query",
        component:resolve => require(['../components/query/query.vue'], resolve),
      },
      {
        
        path:"/order/priceinquiry",
        component:resolve => require(['../components/Priceinquiry/Priceinquiry.vue'], resolve),
        
      }
    ]
  },
  {
    path:'/service', component: resolve => require(['../components/service/service.vue'], resolve),
    redirect:'/service/transportationrode',
    children:[
      {
        path:'/service/transportationrode',
        component: resolve => require(['../components/service/transportationrode.vue'], resolve),
      },
      {
        path:'/service/inland',
        component: resolve => require(['../components/service/inland.vue'], resolve),
      },
      {
        path:'/service/storage',
        component: resolve => require(['../components/service/storage.vue'], resolve),
      },
      {
        path:'/service/packaging',
        component: resolve => require(['../components/service/packaging.vue'], resolve),
      },
      {
        path:'/service/orderline',
        component: resolve => require(['../components/service/orderline.vue'], resolve),
      },
    ]
  },
  {
    path:'/news',component: resolve => require(['../components/news/news.vue'], resolve),
    redirect:'/news/infos',
    children:[
      {
        path:"/news/infos",
        component:resolve => require(['../components/news/infos.vue'], resolve),
        meta:{shownav:true}
      },
      {
        path:"/news/newslist/:id",
        component:resolve => require(['../components/news/newslist.vue'], resolve),
        meta:{shownav:false}
      }
    ]
  },
  {
    path:'/about',component: resolve => require(['../components/about/about.vue'], resolve),
    redirect:'/about/synopsis',
    children:[
      {
        path:'/about/synopsis',
        component: resolve => require(['../components/about/synopsis.vue'], resolve),
      },
      {
        path:'/about/motorcade',
        component: resolve => require(['../components/about/motorcade.vue'], resolve),
      },
      {
        path:'/about/promise',
        component: resolve => require(['../components/about/promise.vue'], resolve),
      },

      {
        path:'/about/process',
        component: resolve => require(['../components/about/process.vue'], resolve),
      },

      {
        path:'/about/insurance',
        component: resolve => require(['../components/about/insurance.vue'], resolve),
      },

    ]
  },
  {
    path:'/contact',component: resolve => require(['../components/contact/contact.vue'], resolve),
    redirect:'/contact/call',
    children:[
      {
        path:'/contact/call',
        component: resolve => require(['../components/contact/call.vue'], resolve),
      },

      {
        path:'/contact/recruit',
        component: resolve => require(['../components/contact/recruit.vue'], resolve),
      },
    ]
  }
 
]
export default new Router({
  // mode:'history',
  routes
})


// WEBPACK FOOTER //
// ./src/router/index.js